import React, { useState } from 'react';
import { useEmail } from '../../context/EmailContext';
import SafeIcon from '../../common/SafeIcon';
import { formatDate } from '../../utils/helpers';

const DraftHistory = () => {
  const { drafts } = useEmail();
  const [filter, setFilter] = useState('All');

  const filteredDrafts = drafts.filter(d => {
    if (filter === 'All') return true;
    return d.status === filter;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'Sendt manuelt': return 'bg-emerald-100 text-emerald-800';
      case 'Klar til send': return 'bg-blue-100 text-blue-800';
      default: return 'bg-slate-100 text-slate-600';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex gap-2">
        {['All', 'Klar til send', 'Sendt manuelt'].map(f => (
          <button 
            key={f} 
            onClick={() => setFilter(f)}
            className={`px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-widest border transition-all ${filter === f ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-500 border-slate-200'}`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50 border-b border-slate-100">
            <tr>
              <th className="px-6 py-4 font-black text-slate-400 uppercase tracking-widest text-[10px]">Dato</th>
              <th className="px-6 py-4 font-black text-slate-400 uppercase tracking-widest text-[10px]">Mottaker</th>
              <th className="px-6 py-4 font-black text-slate-400 uppercase tracking-widest text-[10px]">Emne</th>
              <th className="px-6 py-4 font-black text-slate-400 uppercase tracking-widest text-[10px]">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {filteredDrafts.map(draft => (
              <tr key={draft.draft_id} className="hover:bg-slate-50">
                <td className="px-6 py-4 text-slate-500 font-mono text-xs">{formatDate(draft.created_at)}</td>
                <td className="px-6 py-4">
                  <p className="font-bold text-slate-900">{draft.to_name}</p>
                  <p className="text-xs text-slate-500">{draft.to_email}</p>
                </td>
                <td className="px-6 py-4 text-slate-700 font-medium truncate max-w-[200px]">{draft.subject}</td>
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-widest ${getStatusColor(draft.status)}`}>
                    {draft.status}
                  </span>
                </td>
              </tr>
            ))}
            {filteredDrafts.length === 0 && (
              <tr>
                <td colSpan="4" className="px-6 py-12 text-center text-slate-400">Ingen utkast funnet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DraftHistory;